export * from "./global-footer";
export * from "./global-footer-top";
export * from "./global-footer-bottom";
export { GlobalFooter } from "./async";
